import { Box, DrawerProps } from '@mui/material';
import cx from 'classnames';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { UserContext } from 'context';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { Sidenav } from './Sidenav';
import {
  Brand,
  BrandChip,
  Drawer,
  DrawerContent,
  DrawerTogglePlaceholder,
} from './styles';
import { LayoutMenuSection } from '../types';

export type Props = {
  sections: LayoutMenuSection[];
} & DrawerProps;

export const Sidebar: React.FC<Props> = ({ sections, ...rest }) => {
  const { t } = useTranslation(TranslationNamespace.Common);

  const { sidebarHeaderConfig } = useContext(UserContext);
  const { user } = useUser();

  return (
    <Drawer variant="permanent" {...rest}>
      <DrawerContent>
        <Brand
          component={NavLink as any}
          to="/"
          className="tw-flex-col tw-items-center"
          data-testid="sidebar-header"
        >
          {sidebarHeaderConfig?.name?.visible && (
            <Box m={1}>
              <BrandChip
                label={user.name}
                className={sidebarHeaderConfig.name.className}
              />
            </Box>
          )}
          {sidebarHeaderConfig?.role?.visible && (
            <Box m={1}>
              <BrandChip
                label={t(`role.${user.role}`)}
                className={sidebarHeaderConfig.role.className}
              />
            </Box>
          )}
          {sidebarHeaderConfig?.logo?.visible && (
            <Box className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
              <img
                src={sidebarHeaderConfig.logo.src}
                alt={sidebarHeaderConfig.logo.alt}
                className={cx(
                  sidebarHeaderConfig.logo.className,
                  'tw-max-h-full tw-max-w-full',
                )}
              />
            </Box>
          )}
        </Brand>
        <DrawerTogglePlaceholder />
        <Sidenav sections={sections} />
      </DrawerContent>
    </Drawer>
  );
};
